module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('detail-view', {
    attrs: {
      "endpoint": _vm.endpoint + 'config/settings',
      "name": "Configuration",
      "noPathId": "",
      "permissions": "configuration",
      "values": _vm.values
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b3eac30c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Configuration.vue
// module id = 452
// module chunks = 1